import { selectLocalizedField } from '@/libs/i18n/currentLocale'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export const settingsUtilsMixins = {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      equalsSelect: this.$t('SettingPageCard.equals'),
    }
  },
  computed: {
    sendMethods() {
      return this.$t('SettingPageCard.sendMethods')
    },
    criteria() {
      return this.$t('SettingPageCard.criteria')
    },
    textLang() {
      return selectLocalizedField(this.$i18n, 'swedish_text', 'english_text')
    },
    messageLang() {
      return selectLocalizedField(this.$i18n, 'message', 'eng_message')
    },
  },
  methods: {
    comparisonList(criteriaField) {
      // Be defensive: criteriaField can be undefined or a plain string
      const value = criteriaField && typeof criteriaField === 'object'
        ? criteriaField.value
        : undefined

      // Only allow all comparisons for 'total'; otherwise restrict to '=='
      if (value === 'total') return this.equalsSelect
      return this.equalsSelect.filter(element => element.value == '==')
    },
    renderComparison(params) {
      return this.$t('SettingPageCard.equals').find(
        element => element.value == params,
      )
    },
    popup(message, variant, title, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
          text: message,
        },
      })
    },

    renderSendMethods(params) {
      return this.$t('SettingPageCard.sendMethods').find(
        element => element.value == params,
      )
    },
    renderCriteria(params) {
      return this.$t('SettingPageCard.criteria').find(
        element => element.value == params,
      )
    },
    renderMarkIcon(field) {
      const item = Array.isArray(this.textHelper)
        ? this.textHelper.find(element => element.field == field)
        : null
      return item ? item[this.textLang] : ''
    },
  },
}
